import Axios from "axios";
import flash from "../../../functions/flash";
import { setSpinner } from "../../../store/Store";
import { enable } from "../../endpoints";
import moment from "moment";

const enableUser = async (accessToken, uid, setRefresh) => {
  try {
    setSpinner(true);
    await Axios.post(enable, { accessToken, uid });
    flash("user's has been activated", "success");
    setRefresh(moment().unix());
    setSpinner(false);
  } catch (e) {
    console.log(e.response);
    setSpinner(false);
    flash(e.message, "danger");
  }
};

export default enableUser;
